import React from 'react';

const SOURCES = [
  'Snowflake', 'Databricks', 'BigQuery', 'Redshift',
  'PostgreSQL', 'SQL Server', 'Oracle', 'MySQL',
  'S3 / ADLS', 'Kafka', 'MongoDB', 'Elasticsearch',
  'IoT / Sensors', 'CAD / BIM', 'POS / ERP',
];

export function SourcesLayer() {
  return (
    <section id="sources" className="scroll-mt-24">
      <div className="flex items-center gap-4 mb-5">
        <span className="font-mono text-sm text-white border border-white/20 rounded-lg px-2.5 py-1.5 bg-white/5 shrink-0">01</span>
        <div>
          <h3 className="text-base font-bold text-white">Sources</h3>
          <p className="text-sm text-white/40">Every system of record, connected natively</p>
        </div>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-4 gap-2">
        {SOURCES.map((s) => (
          <div key={s} className="flex items-center gap-2 border border-white/10 rounded-lg bg-white/[0.03] px-2.5 py-2">
            <i className="w-[7px] h-[7px] rounded-sm bg-white/35 shrink-0" />
            <span className="font-mono text-[11px] tracking-wide text-white/60">{s}</span>
          </div>
        ))}
        <div className="flex items-center justify-center border border-dashed border-white/15 rounded-lg px-2.5 py-2">
          <span className="font-mono text-[11px] tracking-wide text-white/30">+ your stack</span>
        </div>
      </div>

      {/* falling data dots */}
      <div className="relative h-11 overflow-hidden" aria-hidden="true">
        {[8, 22, 37, 52, 66, 80, 92].map((left, i) => (
          <span
            key={left}
            className="absolute top-0 w-1 h-1 rounded-full bg-white/85 animate-[fall_1.9s_linear_infinite]"
            style={{ left: `left{left}%`, animationDelay: `left{[0, .5, 1.1, .3, .9, 1.5, .7][i]}s` }}
          />
        ))}
      </div>

      <div className="border border-white/10 rounded-lg bg-white/5 text-center font-mono text-[11px] tracking-[0.2em] uppercase text-white/50 py-2">
        Unified ingestion bus
      </div>
    </section>
  );
}
